import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/lights_out.json";
import fr from "@/locales/fr/puzzle-types/lights_out.json";

export const LIGHTS_OUT_NS = "puzzle-types/lights_out";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerLightsOutTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", LIGHTS_OUT_NS))
    i18n.addResourceBundle("en", LIGHTS_OUT_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", LIGHTS_OUT_NS))
    i18n.addResourceBundle("fr", LIGHTS_OUT_NS, fr, true, true);
}
